import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import ElementContent from "./element-content";


export default function ElementDialog(props: any) {
    const { onClose, open, data } = props;
  
    const handleClose = () => {
        console.log("exp dialog Data:", data);
      onClose();
    };
   
  
    return (
      <Dialog onClose={handleClose} open={open} maxWidth={false}>
        <DialogTitle>DE</DialogTitle>
        <DialogContent dividers style={{minWidth:"900px", minHeight:"300px"}}>
          <ElementContent data={data}></ElementContent>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}> 
          </Button>
        </DialogActions>
      </Dialog>
    );
  }